import { render, staticRenderFns } from "./PushConfiguration.vue?vue&type=template&id=b44c2a8c&scoped=true"
import script from "./PushConfiguration.vue?vue&type=script&lang=js"
export * from "./PushConfiguration.vue?vue&type=script&lang=js"
import style0 from "./PushConfiguration.vue?vue&type=style&index=0&id=b44c2a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44c2a8c",
  null
  
)

export default component.exports